<template>
  <div class="flex-col justify-content-center gap-sm">
    <LoadingIcon :class="
    `icon-size-${size}
     animate-spin
     icon-offset-zero
     fill-primary
     color-primary
     `"></LoadingIcon>
    <template v-if="!noMessage">
      <h3 class="text-center" v-if="message">{{ message }}</h3>
      <h3 class="text-center" v-else>Even geduld aub...</h3>
    </template>
  </div>
</template>

<script>
import Spacings from "../enums/Spacings";

export default {
  name: "LoadingIndicator.vue",
  props: {
    size: {
      required: false,
      type: String,
      default: 'xxl',
      validator(value) {
        return Object.keys(Spacings).includes(value);
      }
    },
    message: {
      type: String,
      required: false,
    },
    noMessage: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.animate-spin {
  animation: spin .6s ease-in infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
